export const GRID_SNAP_SIZE = 12;

export interface GridPoint {
  x: number;
  y: number;
}

export const snapPointToGrid = (
  point: GridPoint,
  gridSize: number = GRID_SNAP_SIZE,
): GridPoint => {
  const size = Math.max(1, gridSize);
  return {
    x: Math.round(point.x / size) * size,
    y: Math.round(point.y / size) * size,
  };
};

export const snapNodePositionToGrid = <T extends GridPoint>(
  node: T,
  gridSize: number = GRID_SNAP_SIZE,
): T => {
  const snapped = snapPointToGrid(node, gridSize);
  if (snapped.x === node.x && snapped.y === node.y) {
    return node;
  }
  return {
    ...node,
    x: snapped.x,
    y: snapped.y,
  };
};
